<template>
  <div class="unique-slider-wrapper">
    <h2 id="seasons">{{actionTitle}}
    <br/>{{title}}</h2>
    <div class="description" v-html="description"></div>
    <div class="slider-pills" role="filters">
      <button @click="filterSlides('all'); resetScrollPosition()" aria-label="All Birds" class="slider-pill" :aria-selected="tab1">All Birds</button>
      <button @click="filterSlides('yearly'); resetScrollPosition()" aria-label="Year Round Birds" class="slider-pill" :aria-selected="tab2">Year Round</button>
      <button @click="filterSlides('summer'); resetScrollPosition()" aria-label="Summer Birds" class="slider-pill" :aria-selected="tab3">Summer</button>
      <button @click="filterSlides('winter'); resetScrollPosition()" aria-label="Winter Birds" class="slider-pill" :aria-selected="tab4">Winter</button>
    </div>
    <div class="unique-slider" :class="onHover">
      <button v-if="!scrollLeft1" aria-label="Previous Image control" class="btn arrow" @click="firstRowPrev()" href="#">
        <IconBase variant="angle-left" width="30" height="30" classes="left" />
      </button>
      <ul ref="slider1" class="slider1" :class="fewerSlides">
        <li v-for="(slide, index) in this.firstRow" ref="slide1" :key="index" class="slide1">
          <figure>
            <b-img-lazy :src="slide.imageurl" :alt="slide.imagealt" class="slide-image" />
          </figure>
          <div class="slide-title">{{slide.name}}</div>
        </li>
      </ul>
      <button v-if="this.firstRow.length > 8 && !scrollRight1" aria-label="Next Image control" class="btn arrow" @click="firstRowNext();" href="#">
        <IconBase variant="angle-right" width="30" height="30" classes="right" />
      </button>
    </div>
    <div class="unique-slider" :class="onHover">
      <button v-if="!scrollLeft2" aria-label="Previous Image control" class="btn arrow" @click="secondRowPrev()" ref="prev2" href="#">
        <IconBase variant="angle-left" width="30" height="30" classes="left" />
      </button>
      <ul ref="slider2" class="slider2" :class="fewerSlides">
        <li v-for="(slide, index) in this.secondRow" :key="index" id="slide" class="slide2">
          <figure>
            <b-img-lazy :src="slide.imageurl" :alt="slide.imagealt" class="slide-image" />
          </figure>
          <div class="slide-title">{{slide.name}}</div>
        </li>
      </ul>
      <button v-if="this.secondRow.length > 8 && !scrollRight2" aria-label="Next Image control" class="btn arrow" @click="secondRowNext();" href="#">
        <IconBase variant="angle-right" width="30" height="30" classes="right" />
      </button>
    </div>
  </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import IconBase from './icons/index.vue';

@Component({
  components: {
    IconBase,
  },
  data() {
    return {
      all: true,
      notEnoughSlides: false,
      scroll: null,
      scrollLeft1: false,
      scrollRight1: false,
      scrollLeft2: false,
      scrollRight2: false,
      secondRow: [],
      slide: 0,
      sliding: null,
      sliderActive: false,
      summer: false,
      tab1: true,
      tab2: false,
      tab3: false,
      tab4: false,
      winter: false,
      yearly: false,
      loaded: false,
    };
  },
  methods: {
    firstRowNext() {
      const uniqueSlider = document.querySelector('.slider1');
      const slide = document.querySelector('.slide1');
      const slideWidth = slide.clientWidth + 16;
      uniqueSlider.scrollLeft += slideWidth;
    },
    firstRowPrev() {
      const uniqueSlider = document.querySelector('.slider1');
      const slide = document.querySelector('.slide1');
      const slideWidth = slide.clientWidth + 16;
      uniqueSlider.scrollLeft -= slideWidth;
    },
    secondRowNext() {
      const uniqueSlider = document.querySelector('.slider2');
      const slide = document.querySelector('.slide2');
      const slideWidth = slide.clientWidth + 16;
      uniqueSlider.scrollLeft += slideWidth;
    },
    secondRowPrev() {
      const uniqueSlider = document.querySelector('.slider2');
      const slide = document.querySelector('.slide2');
      const slideWidth = slide.clientWidth + 16;
      uniqueSlider.scrollLeft -= slideWidth;
    },
    resetScrollPosition() {
      const scrollPosition1 = this.$refs.slider1.scrollLeft;
      const scrollPosition2 = this.$refs.slider2.scrollLeft;
      const uniqueSlider1 = document.querySelector('.slider1');
      const uniqueSlider2 = document.querySelector('.slider2');

      if ((scrollPosition1 > 0) || (scrollPosition2 > 0)) {
        uniqueSlider1.scrollLeft = 0;
        uniqueSlider2.scrollLeft = 0;
      }
    },
  },
  computed: {
    firstRow() {
      const alphaSlides = this.slides.sort((a, b) => a.name.localeCompare(b.name));
      alphaSlides.forEach((e, index) => { e.index = index; });

      if (this.all === true) {
        const divided = Math.ceil(alphaSlides.length / 2);
        const first = alphaSlides.slice(0, divided);
        const second = alphaSlides.slice(divided);
        this.secondRow = [...new Set(second)];
        this.notEnoughSlides = false;
        this.tab1 = true;
        this.tab2 = false;
        this.tab3 = false;
        this.tab4 = false;

        return first;
      }
      if (this.yearly === true) {
        const yearlySlides = alphaSlides.filter(slide => slide.season === 'Yearly');
        if (yearlySlides && yearlySlides.length < 8) {
          const yearly = yearlySlides;
          this.secondRow = [];
          this.notEnoughSlides = true;
          this.tab2 = true;
          this.tab1 = false;
          this.tab3 = false;
          this.tab4 = false;
          return yearly;
        }
        const divided = Math.ceil(yearlySlides.length / 2);
        const first = yearlySlides.slice(0, divided);
        const second = yearlySlides.slice(divided);
        this.secondRow = [...new Set(second)];
        this.tab2 = true;
        this.tab1 = false;
        this.tab3 = false;
        this.tab4 = false;

        return first;
      }
      if (this.summer === true) {
        const summerSlides = alphaSlides.filter(slide => slide.season === 'Summer');
        if (summerSlides && summerSlides.length < 8) {
          const summer = summerSlides;
          this.secondRow = [];
          this.notEnoughSlides = true;
          this.tab3 = true;
          this.tab1 = false;
          this.tab2 = false;
          this.tab4 = false;
          return summer;
        }
        const divided = Math.ceil(summerSlides.length / 2);
        const first = summerSlides.slice(0, divided);
        const second = summerSlides.slice(divided);
        this.secondRow = [...new Set(second)];
        this.notEnoughSlides = false;
        this.tab3 = true;
        this.tab1 = false;
        this.tab2 = false;
        this.tab4 = false;

        return first;
      }
      if (this.winter === true) {
        const winterSlides = alphaSlides.filter(slide => slide.season === 'Winter');
        if (winterSlides && winterSlides.length < 8) {
          const winter = winterSlides;
          this.secondRow = [];
          this.notEnoughSlides = true;
          this.tab4 = true;
          this.tab3 = false;
          this.tab1 = false;
          this.tab2 = false;

          return winter;
        }
        const divided = Math.ceil(winterSlides.length / 2);
        const first = winterSlides.slice(0, divided);
        const second = winterSlides.slice(divided);
        this.secondRow = [...new Set(second)];
        this.notEnoughSlides = false;
        this.tab4 = true;
        this.tab3 = false;
        this.tab1 = false;
        this.tab2 = false;

        return first;
      }
      return false;
    },
    onHover() {
      return this.notEnoughSlides ? 'no-hover' : 'on-hover';
    },
    fewerSlides() {
      return this.firstRow.length < 8 || this.secondRow.length < 8 ? 'centered' : '';
    },
  },
})

class UniqueDataSlider extends Vue {
  @Prop({ type: Array })
  slides;

  @Prop({ type: String })
  actionTitle;

  @Prop({ type: String })
  title;

  @Prop({ type: String })
  description;

  @Prop({ type: Number })
  sliderCount;

  async filterSlides(tab) {
    switch (tab) {
      case 'all':
        this.all = true;
        this.yearly = false;
        this.summer = false;
        this.winter = false;
        break;
      case 'yearly':
        this.all = false;
        this.yearly = true;
        this.summer = false;
        this.winter = false;
        break;
      case 'summer':
        this.all = false;
        this.summer = true;
        this.yearly = false;
        this.winter = false;
        break;
      case 'winter':
        this.all = false;
        this.winter = true;
        this.summer = false;
        this.yearly = false;
        break;
      default:
        break;
    }
  }

  async mounted() {
    const scroll1 = this.$refs.slider1;
    const scroll2 = this.$refs.slider2;
    scroll1.addEventListener('scroll', () => {
      const scrollPosition1 = this.$refs.slider1.scrollLeft;

      if ((window.innerWidth < 1180) && scrollPosition1 > ((this.firstRow.length - 5) * 166)) {
        this.scrollRight1 = true;
      } else if (((window.innerWidth >= 1180) && (window.innerWidth < 1366)) && scrollPosition1 > ((this.firstRow.length - 6) * 166)) {
        this.scrollRight1 = true;
      } else if (((window.innerWidth >= 1366) && (window.innerWidth < 1919)) && scrollPosition1 > ((this.firstRow.length - 7) * 166)) {
        this.scrollRight1 = true;
      } else if ((window.innerWidth >= 1919) && scrollPosition1 > ((this.firstRow.length - 8) * 166)) {
        this.scrollRight1 = true;
      } else {
        this.scrollRight1 = false;
      }
      if (scrollPosition1 < 166) {
        this.scrollLeft1 = true;
      } else {
        this.scrollLeft1 = false;
      }
    }, false);
    scroll2.addEventListener('scroll', () => {
      const scrollPosition2 = this.$refs.slider2.scrollLeft;

      if ((window.innerWidth < 1180) && scrollPosition2 > ((this.firstRow.length - 5) * 166)) {
        this.scrollRight2 = true;
      } else if (((window.innerWidth >= 1180) && (window.innerWidth < 1366)) && scrollPosition2 > ((this.firstRow.length - 6) * 166)) {
        this.scrollRight2 = true;
      } else if (((window.innerWidth >= 1366) && (window.innerWidth < 1919)) && scrollPosition2 > ((this.firstRow.length - 7) * 166)) {
        this.scrollRight2 = true;
      } else if ((window.innerWidth >= 1919) && scrollPosition2 > ((this.firstRow.length - 8) * 166)) {
        this.scrollRight2 = true;
      } else {
        this.scrollRight2 = false;
      }
      if (scrollPosition2 < 166) {
        this.scrollLeft2 = true;
      } else {
        this.scrollLeft2 = false;
      }
    }, false);
  }
}

export default UniqueDataSlider;
</script>

<style lang="scss" scoped>

.btn.arrow {
  border: none;
  opacity: 0;
  padding: 0px;
  z-index: 1;
}
.btn.arrow:focus,
.btn.arrow:focus-visible {
  box-shadow: none;
  opacity: 1;
}
.prev, .next {
  color: #000;
  font-weight: normal;
  opacity: 0.6;
  position: relative;
  text-decoration: none;
  transition: opacity 100ms;
  z-index: 1;

  @media only screen and (min-width: 930px) {
    cursor: pointer;
    position: absolute; }
}
.next {
  display: none;

  @media only screen and (min-width: 930px) {
    align-items: center;
    display: block;
    right: 50px;
    top: 70px; }
  @media only screen and (min-width: 1400px) {
    right: 200px; }
  @media only screen and (min-width: 2560px) {
    right: 500px; }
}
.prev {
  display: none;

  @media only screen and (min-width: 930px) {
    align-items: center;
    display: block;
    left: 50px;
    top: 70px; }
  @media only screen and (min-width: 1400px) {
    left: 200px; }
  @media only screen and (min-width: 2560px) {
    left: 500px; }
}
.prev:hover,
.prev:focus-visible,
.next:hover,
.next:focus-visible {
  color: #4c8ea0!important;
  text-decoration: none;
}
.unique-slider-wrapper {
  margin-top: 100px;
  width: 100%;
}
.description {
  margin-bottom: var(--spacing-xl);
  margin-left: auto;
  margin-right: auto;
  margin-top: var(--spacing-xxs);
  width: 320px;

  @media only screen and (min-width: 768px) {
    width: 460px; }
  @media only screen and (min-width: 1024px) {
    width: 620px; }
}
.slider-pills {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: var(--spacing-m);

  @media only screen and (min-width: 1024px) {
    flex-wrap: nowrap;
  }
}
.slider-pill {
  align-items: center;
  border: solid 1px #173945;
  border-radius: 36px;
  background-color: #fff;
  color: #173945;
  display: flex;
  margin-bottom: 20px;
  margin-right: 6px;
  padding: 12px 24px 12px 24px;
  transition: box-shadow 350ms ease-in-out;
}
[aria-selected="true"],
.slider-pill:focus,
.slider-pill:hover,
.slider-pill:focus-visible {
  background-color: #173945;
  color: #fff;
  outline: #173945;
}
.unique-slider {
  height: 260px;
  margin: 0 auto;
  overflow: hidden;
  scroll-snap-type: x proximity;
  position: relative;
  justify-content: center;
  display: flex;
}
.on-hover {
  &:focus,
  &:focus-visible {
    .btn.arrow {
      opacity: 1;
    }
  }
}
.on-hover {
  &:hover {
    .btn.arrow {
      opacity: 1;
    }
  }
}
.slider1, .slider2 {
  display: flex;
  flex-direction: row;
  list-style-type: none;
  overflow-y: hidden;
  padding: 0px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  text-align: center;
  width: 98%;

  @media only screen and (min-width: 667px) {
    width: 90%; }
  @media only screen and (min-width: 720px) {
    width: 94%; }
  @media only screen and (min-width: 768px) {
    width: 98%; }
  @media only screen and (min-width: 820px) {
    width: 90%; }
  @media only screen and (min-width: 844px) {
    width: 88%; }
  @media only screen and (min-width: 896px) {
    width: 80%; }
  @media only screen and (min-width: 1024px) {
    width: 80%; }
  @media only screen and (min-width: 1180px) {
    width: 84%; }
  @media only screen and (min-width: 1440px) {
    width: 69%; }
  @media only screen and (min-width: 1728px) {
    width: 67%; }
  @media only screen and (min-width: 1919px) {
    width: 69%; }
  @media only screen and (min-width: 2560px) {
    width: 1320px; }
}
.slider1::-webkit-scrollbar,
.slider2::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.slide1, .slide2 {
  flex: 1 0 10%;
  height: 230px;
  margin: 8px;
  pointer-events: auto;
  scroll-snap-align: start;
  scroll-snap-stop: normal;
  width: 150px;
  max-width: 150px;
}
.slider:active {
  color: red;
}
.centered {
  @media only screen and (min-width: 930px) {
    justify-content: center;
  }
}
.slide-image {
  border-radius: 50%;
  height: 150px;
  width: 150px;
}
.slide-title {
  margin-top: 5px;
}

</style>
